import { Language } from "../LanguageConfig";
import {format} from "date-fns";
import {DateFormat} from "../../helpers/Formatting";



export const English: Language = {
    locale: 'en-GB',
    languageIdentifier: "english",
    language: "Language",
    common: {
        description: "Description",
        reason: "Reason",
        form: {
            lockedValues: {
                title: "Lock values into place",
                helpText: 'If you select “Lock values into place”, selected form values will be temporarily stored for further entries. The values are locked until you remove them!'
            },
            removeLockValues: "Remove locked values"
        },
        control: "Control",
        mainMenu: "Main menu",
        invoices: "Invoices",
        reports: "Reporting",
        immediately: "Immediately",
        replace: "Replace",
        contractor: "Contractor",
        unsavedDataWarning: {
            title: "Leave page?",
            helpText: "You may have unsaved data. They will be lost when you leave the page, do you want to continue?"
        },
        origin: "Origin",
        emptyCache: {
            buttonText: 'Empty local cache',
            tooltipText: 'The local cache will be emptied. All unsaved data in the cache will be lost.'
        },
        sender: "Sender",
        recipient: "Recipient",
        status: "Status",
        solvencyReport: "Project solvency report",
        import: {
            tooltipText: "Import data or the current site.",
            buttonText: "Import"
        },
        export: {
            tooltipText: "Export the currently shown data.",
            buttonText: "Export"
        },
        total: 'Total',
        summary: 'Summary',
        files: "Files",
        uploadFile: {
            buttonText: 'Upload file',
            tooltipText: 'Choose one or more files to upload and attach to this entry.'
        },
        all: 'All',
        justSelected: 'Also marked',
        onlyCurrent: 'Only this one',
        remaining: 'Remaining',
        active: 'Active',
        removeButton: {
            buttonText: 'Remove',
            tooltipText: 'Remove selection'
        },
        not: 'Not',
        filterInvert: {
            buttonText: 'Inverted',
            tooltipText: 'The selection is inverted. Example: Choosing a project and inverting it will display all data, but not data associated with the chosen project.'
        },
        add: 'Add',
        internal: "Internal",
        stepBack: {
            buttonText: "Back",
            tooltipText: "Go to previous page"
        },
        searchBox: {
            placeholderText: "Search..."
        },
        currentEntry: "Current entry",
        entry: 'Entry',
        newEntry: {
            buttonText: "Add entry",
            tooltipText: "Add a new entry"
        },
        editEntry: {
            buttonText: "Edit",
            tooltipText: "Edit this entry"
        },
        deleteEntry: {
            buttonText: "Delete",
            tooltipText: "Delete this entry"
        },
        restoreEntry: {
            buttonText: "Restore",
            tooltipText: "Restore the entry"
        },
        cancel: {
            buttonText: "Cancel",
            tooltipText: "Cancel and back"
        },
        isDeleted: "deleted",
        showDetail: {
            buttonText: "Show detail",
            tooltipText: "Show detail of this entry"
        },
        sorting: {
            buttonText: "Sort",
            tooltipText: "Change the way the entries on this site is sorted."
        },
        sortAsc: {
            buttonText: "Sort ascending",
            tooltipText: "Sort ascending"
        },
        sortDesc: {
            buttonText: "Sort descending",
            tooltipText: "Sort descending"
        },
        filterButton: {
            buttonText: "Filter",
            tooltipText: "Add filters to narrow the list of entries"
        },
        backToHome: {
            tooltipText: "Jump to dashboard"
        },
        markAsRead: {
            buttonText: "Read",
            tooltipText: "Mark as read"
        },
        markAsUnread: {
            buttonText: "Unread",
            tooltipText: "Mark as unread"
        },
        expandText: {
            buttonText: "Expand Text",
            tooltipText: "Show the whole text"
        },
        contractText: {
            buttonText: "Contract text",
            tooltipText: "Show only the short version of the text"
        },
        closeButton: {
            buttonText: "Close",
            tooltipText: "Close"
        },
        jumpToEntry: {
            buttonText: "To entry",
            tooltipText: "Jump to entry"
        },
        stepForward: {
            buttonText: "Next",
            tooltipText: "Next step"
        },
        resetButton: {
            buttonText: "Reset"
        },
        submitButton: {
            buttonText: "Save"
        },
        confirmDelete: { 
            question: "Confirm delete",
            standardText: "Do you really want to delete this entry?"
        },
        confirmRestore: {
            question: "Confirm restore",
            standardText: "Do you really want to restore this entry?"
        },
        inputSwitch: {
            labelTrue: "Yes",
            labelFalse: "No"
        },
        importantTitle: "Important",
        tabBaiscInfo: "Basic info",
        per: "per",
        yes: "Yes",
        no: "No",
        address: "Address",
        disablePlaceSearch: {
            helpText: "If disabled, address has to be entered manually.",
            title: "Address-search active"
        },
        street: "Street",
        houseNumber: "House number",
        country: "Country",
        city: "City",
        postal: "Zip-Code",
        province: "Bundesland",
        name: "Name",
        office: "Office",
        allowed: "Is allowed?",
        module: "Module",
        begin: "Start",
        end: "End",
        contactSingular: 'Contact',
        contactPlural: 'Contacts',
        userDefined: "User defined",
        notAssigned: "Not assigned",
        selectPlaceholder:"Select",
        lockStatusTitle: {
            buttonText: "Lock status",
            tooltipText: "Displays the status of the lock of the entry. The lock can be in four states: Open, closed external, closed internal and completely closed."
        },
        lockStatus: {
            0: {
                title: "Open",
                tooltip: "the entry can change in every way"
            },
            1: {
                title: "External",
                tooltip: "The entry belongs to a project, was billed and is accounted for, it can not change from this point forward."
            },
            2: {
                title: "Internal",
                tooltip: "The entry was internally accounted and can only change on external entries."
            },
            3: {
                title: "Locked",
                tooltip: "The entry can never change."
            }
        },
        tag: {
            buttonText: "Tag",
            tooltipText: "Words that describe an entry. Through tags you can easily find entries with the same tags."
        },
        category: {
            buttonText: "Category",
            tooltipText: "Provides the possibility to categorize the entry with other similar entries."
        },
        dateName: 'Date',
        attachment: {
            buttonText: "Attachment",
            tooltipText: "Attachments"
        }
    },
    ajaxResponse: {
        informAdmin: "If the problem persists, please inform the administrator!",
        savingSuccess: "Entry successfully saved!",
        deleteSuccess: "Entry successfully deleted!",
        restoreSuccess: "Entry successfully restored!",
        errors: {
            errorAppeared: ( view: string, action: string ) => `Der Fehler trat auf in ${ view }::${ action }.`,
            400: 'The request was malformed and could not be parsed by the API-Server! This could be due to faulty entries in forms.',
            401: 'The requested resource was not found!',
            404: `The chosen path does not exist on the API-Server! `,
            500: 'The backend server replied with an internal error',
            loginWrongPassword: 'The given password is wrong!',
            loginUserNotFound: 'The given email was not found on the system!'
        },
    },
    groups: {
        title: "User groups",
        rowAreas: "Areas",
        rowName: "Name",
        rowDataBased: "Data based group?",
        form: {
            stepBasicInfoLabel: "User group main data",
            stepPrivilegesLabel: "Privilege assignment",
            dataBasedHelperText: "Data based group means, the privileges within this group are not applied to the employee, if he is not attached with data in the area. Example: Max is part of the ProjectWorker group, so he should see projects. But as long as he is not attached to a project, he will not see any projects."
        }
    },
    timesheet: {
        title: "Timesheet",
        hoursPerWeek: "Hours per week",
        hoursCurrentWeekWithArgs: ( mandatoryHours: number | string, realHours: number | string ) => `You have worked ${realHours} of ${mandatoryHours} hours this week`,
        hoursCurrentWeek: "Hours this week",
        mandatoryHours: "Mandatory hours",
        realHours: "Actual hours",
        rowTask: "Task",
        rowHoursOfWork: "Work hours",
        rowTime: "Time of day",
        timeOfEntry: "Time of entry",
        serialAppointment: "Series-appointment",
        serialAppointmentPlural: "Series-appointment",
        form: {
            journey: "Journey to customer",
            weight: "Weight",
            startDate: "Date",
            endDate: "Until",
            checkboxEnddate: "Create entry until...",
            predefinedDescriptions: "Predefined descriptions",
            description: "Work description",
            checkboxContainer: "Options",
            wholeDay: "Whole day of work",
            internalHelp: "Entries marked as internal include all work for the employer and sick-leave, vacation days...Internal entries are marked with yellow color in the timesheet and calendar.",
            seriesAppointmentHelp: 'Seriesappointments will create the entry every time the chosen interval hits. The series can never be longer than one year.',
            wholeDayHelp: 'The mandatory hours of the employee will automatically be applied to this entry. To provide a simple solution for vacation-days or sick-leave, the system will create a series-appointment automatically and create an entry each workday of the employee until the chosen date.',
            mandatoryDescriptionMissing: "The chosen task requires a description!"
        },
        series: {
            dateInterval: {
                0: "Daily",
                1: "Weekly",
                2: "Every two weeks",
                3: "Monthly",
                4: "Yearly"
            },
            finishAt: "End of the series",
            interval: "Interval"
        },
        confirmSeriesSelection: {
            text: "Choose the entries that should be changed too."
        }
    },
    help: {
        title: "Help"
    },
    notification: {
        title: "Notifications",
        unreadNotificationTitle: "Unread notifications",
        unreadNotificationsWithArgs: ( unreadNotifyCount: number ) => `You have ${ unreadNotifyCount } unread notifications`,
        noUnreadNotifications: "You have no unread notifications"
    },
    userSettings: {
        title: "Account management",
        mainMenuTooltip: "Open menu",
        columnSelector: {
            title: "Column selection",
            button: {
                buttonText: "Column selection",
                tooltipText: "Change visibility of columns to display more or less information."
            }
        },
        rowsPerPage: 'Entries per page',
        toPage: (page: number ) => `Show page ${page}`,
        nextPage: 'Next page',
        previousPage: 'Previous page',
        currentPage: 'Current page',
        totalEntries: ( totalEntries: number ) => `Total entries: ${ totalEntries }`,
        activeFilters: 'Active filters',
        viewSettings: {
            buttonText: "View settings",
            tooltipText: "Save view settings and set previously saved settings"
        },
        defaultSettings: "Default settings",
        saveSettings: "Save settings",
        refreshData: "Refresh data"
    },
    cookieBanner: {
        title: "Usage of cookies",
        description: "We transmit personal data to third-party providers in order to improve our website. In this context, usage profiles (e.g. based on cookie IDs) are also created and enriched, including outside the EEA. We require your consent for this and to use certain services for the following purposes. By clicking “Accept”, you consent to this. This also includes your consent to the transfer of certain personal data to third countries, including the USA, which is considered an unsafe third country.",
        decline: "Deny",
        consent: "Accept"
    },
    projects: {
        retailPricePerHour: {
            helpText: "The retail price per hour",
            title: "Retail price per hour",
            shorthand: "RP / hr."
        },
        purchasePricePerHour: {
            helpText: "The purchase price per hour",
            title: "Purchase price per hour",
            shorthand: "PP / hr."
        },
        projectReport: {
            title: "Project report"
        },
        saveAndLeave: "Speichern und verlassen",
        basedOn: "Based on ",
        basedOnStageHelper: "This addendum is based on the selected stage/addendum",
        addAddendum: "Add addendum",
        workingPeriod: {
            title: "Working period",
            shorthand: "Work period",
            helpText: "The employees working period in a specific task. Only during this period the employee has the right to insert work times for this task."
        },
        avgPurchasePricePerHour: {
            title: "Average purchase price per hour",
            shorthand: "Avg. PP / Hour.",
            helpText: "The average purchase price per hour."
        },
        avgRetailPricePerHour: {
            title: "Average retail price per hour",
            shorthand: "Avg. RP / hour",
            helpText: "The average retail price per hour."
        },
        optionalRetailPrice: {
            helpText: "Optional sales price is a value that indicates potential for further sales. For example, optional project parts that could be commissioned.",
            shorthand: "Opt. RP",
            title: "Optional retail price",
        },
        newEntry: {
            buttonText: "Create project",
            tooltipText: "Create a new project"
        },
        editEntry: {
            buttonText: "Edit project",
            tooltipText: "Edit this project."
        },
        deleteEntry: {
            buttonText: "Delete project",
            tooltipText: "Delete this project"
        },
        restoreEntry: {
            buttonText: "Restore project",
            tooltipText: "Restore this project"
        },
        plannedProfitMargin: "Planned profit margin",
        profitMargin: "Profit margin",
        profitMarginPercent: "Profit margin ( % )",
        assignedProfitMargin: {
            title: "Virtual profit margin",
            helpText: "The virtual profit margin is calculated from the sales price minus allocated purchase prices for employees, contractors and other costs for the company."
        },
        assignedManHours: "Assigned man-hours",
        plannedManHours: "Planned man-hours",
        status: {
            INACTIVE: "Inactive",
            ACTIVE: "Active",
            PAUSED:"Paused",
            DONE:"Done",
            LOCKED: "Locked"
        },
        title: "Projects",
        performancePluralEdit: {
            title: "Edit performances",
            helpText: "All performances editable on one page."
        },
        currentPerformance: {
            title: "Current performance",
            helpText: ""
        },
        newPerformance: {
            title: "New performance",
            helpText: ""
        },
        addendum: "Addendum",
        rowProject: "Project",
        rowProjectStage: "Step",
        rowProjectStagePhase: "Phase",
        jumpToProjectWithArgs: ( projectTitle: string ) => `Jump to project ${ projectTitle }`,
        purchasePrice: {
            title: 'Purchase price',
            shorthand: 'PP',
            helpText: 'The purchase price displays the amount of costs the company has to calculate for this point.'
        },
        assignedPurchasePrice: {
            title: 'Assigned purchase price',
            shorthand: 'Assigned PP',
            helpText: 'Assigned purchase price displays the amount of costs that are already tied in contracts.'
        },
        usedPurchasePrice: {
            title: 'Used purchase price',
            shorthand: 'Used PP',
            helpText: 'Used purchase price displays the amount of costs that are already paid to contractors or booked hours by employees.'
        },
        plannedPurchasePrice: {
            title: 'Planned purchase price',
            shorthand: 'Planned PP',
            helpText: 'Planned purchase price displays the amount of costs as estimated during the planning phase.'
        },
        retailPrice: {
            title: 'Retail price',
            shorthand: 'RP',
            helpText: 'The retail price displays the amount of invoice the customer has to pay for this point.'
        },
        additionalCosts: {
            title: 'Incidental costs',
            helpText: 'Added to the retail price for paper, phone and network infrastructure'
        },
        additionalCostsInPercent: {
            title: 'Incidental costs in %',
            helpText: 'Percentage added to the retail price for paper, phone and network infrastructure'
        },
        projectAddress: "Address of the construction site",
        mainOrder: {
            title: "Ḿain order",
            helpText: "Main order retail price of the ordered project. Appendices are not included in this value."
        },
        totalOrder: {
            title: "Total order",
            helpText: "Total order of the ordered project. Total order = main order + sum appendices"
        },
        internalWorkOrder: {
            title: "Internal order",
            helpText: "Internal order of the ordered project. Appendices are not included in this value"
        },
        contractedWorkOrder: {
            title: "Contractor order",
            helpText: "Contractor order of the ordered project. Appendices are not included in this value"
        },
        health: 'Health',
        healthBad: 'bad',
        healthOk: 'good',
        healthWarning: 'warning',
        projectLeadSubstitute: 'project lead substitute',
        projectLead: 'project lead',
        retailPriceUsed: "Budget spent",
        budgetCondition: 'Budget health',
        performance: 'Performance',
        hourlyInternalCosts: {
            title: 'Hourly internal costs',
            helpText: 'This value will be calculated into used budget. See the longer explanation, on the help page, to learn how.'
        },
        hourlyRate: {
            title: 'Hourly timerate',
            helpText: 'When the order is billed by hours, this value will be used to calculate the total amount billed.'
        },
        addPhaseButton: {
            tooltipText: 'Add a project phase to this stage',
            buttonText: 'Add phase'
        },
        addStageButton: {
            tooltipText: 'Add a stage to this project',
            buttonText: 'Add stage'
        },
        projectRole: {
            title: 'Role',
            helpText: 'The position in the project the employee has. The roles come with certain privileges and duties.'
        },
        legacyProjectNumber: {
            title: 'Legacy project number',
            helpText: 'When a project existed before this software was introduced, use this field to enter the project number used previously.'
        },
        stageTypeSelect: {
            title: 'Stagetype',
            helpText: 'The type of the stage defines the values a stage needs to function.'
        },
        commissionAt: {
            tooltipText: 'Customer commissioned at this date',
            buttonText: 'Commissioned at'
        },
        contractSignatureDate: {
            tooltipText: 'At this date the contract was signed',
            buttonText: 'Contract signature date'
        },
        contractSignatureCustomerDate: {
            tooltipText: 'At this date the contract was signed by the customer',
            buttonText: 'Contract signature date customer'
        },
        workHoursUsed: {
            tooltipText: "Hours logged onto this project/stage/phase by employees",
            buttonText: "Hours used"
        },
        stageTypes: {
            stage_addendum_external: {
                title: 'External addendum',
                helpText: 'This stage contains an project addendum that is being worked on by a contractor.'
            },
            stage_addendum_internal: {
                title: 'Internal addendum',
                helpText: 'This stage contains an project addendum that is being worked on internally.'
            },
            stage_external: {

                title: 'External',
                helpText: 'This stage is being worked on by a contractor.'
            },
            stage_internal: {
                title: 'Internal',
                helpText: 'This stage is being worked on internally.'
            }

        },
        form: {
            phaseExistsError: "This phase already exists for the chosen stage.",
            stepTitleBasicInfo: 'Basic info',
            shortDescription: {
                title: 'Short identifying name',
                helpText: 'Will be displayed with the project number.'
            },
            projectStageCreate: {
                buttonText: "Add stage",
                tooltipText: "Create a new stage in this project."
            },
            projectPhaseCreate: {
                buttonText: "Add phase",
                tooltipText: "Create a new phase in this stage."
            },
            description: 'Description',
            plannedCosts: "Planned costs",
            budget: "Auftragsvolumen",
            phaseSubmitButtonText: "Save phase",
            projectSubmitButtonText: "Save project",
            stageSubmitButtonText: "Save stage",
            employeeSubmitButtonText: "Save employee",
            addContractor: "Add contractor",
            addEmployee: "Add employee"
        },
        order: "Auftrag",
        projectBillType: {
            none: "Not an invoice item",
            partial_invoice: "Invoice item for partial invoices",
            single_invoice_flat: "Invoice item for flat rate based single invoices",
            single_invoice_time: "Invoice item for time based single invoices"
        },
        timeRetailPricePerHourType: {
            flat_based: "Use one fixed price per hour",
            role_based: "Use project roles of employees"
        }
    },    
    errors: {
        title: "Error",
        defaultFallback: "Default value is set for resource",
        sensitive: {
            notPermitted: { errorText: "You don't have permission to access this resource!" },
            notFound: { errorText: "This resource could not be found!" },
            corrupted: { errorText: "This resource is corrupted!" },
            typeError: { errorText: "This resource is of the wrong type!" }
        },
        errorBoundaryMessage: {
            errorText: 'A fatal error occured! Please refresh the page with CTRL + R ( macOS: CMD + R )! Please inform the administrator if the problem persists.'
        },
        pageAccessDenied: {
            errorText: "You don't have the neccessary permissions to access this page!",
        },
        noData: {
            errorText: "No data found!"
        },
        form: {
            overMax: { errorText: "Values cannot be greater than $$[max]!" },
            underMin: { errorText: "Values cannot be lower than $$[min]!" },
            notANumber: {
                errorText: "Only numeric characters and . or , are allowed in this field",
            },
            requiredFieldNotFilled: {
                errorText: "This field is required and can't be empty"
            },
            savingFormFailed: {
                errorText: "Saving entry failed!"
            },
            passwordDontMatch: { errorText: "The entered passwords must match!" },
            dateEarlierThan: ( date: Date ) => `The chosen date has to be earlier than ${ format( date, DateFormat ) }!`,
            dateLaterThan: ( date: Date ) => `The chosen date has to be later than ${ format( date, DateFormat ) }!`,
            dateNotParseable:{ errorText: "The entered date could not be verified. Use DD.MM.YYYY format only please." },
            timeEarlierThan: ( date: Date ) => `The chosen time must be earlier than ${ format( date, DateFormat ) }!`,
            timeLaterThan: ( date: Date ) => `The chosen time must be later than ${ format( date, DateFormat ) }!`,
            timeNotParseable:{ errorText: "The chosen time could not be verified, please only use the following format: HH:MM" },
            emailAlreadyExists: { errorText: "The chosen email already exists! This email has to be unique!" },
            exceedsLimit: ( limit: string ) => "The chosen value is above the Limit of "+ limit
        }
    },
    privileges: {
        'view.can_view': { title: "Can access page", helpText: "Should the user be able to access this page?"},
        'view.can_create': { title: "Can create entries", helpText: "Should the user be able to create new entries on this page?"},
        'view.can_edit': { title: "Can edit entries", helpText: "Should the user be able to edit entries on this page?"},
        'view.can_delete': { title: "Can delete entries", helpText: "Should the user be able to delete entries on this page?"},
        'can_restore': { title: "Can restore entries", helpText: "Should the user be able to see deleted entries and be able to restore them?"},
        'can_access_sensitive': { title: "Can access sensitive data", helpText: "Should the user be able to access sensitive data on this page?"},
        'view.can_download_files': { title: "Can download files", helpText: "Should the user be able to download files?"},
        'can_add_users_to_user_group': { title: "Can add employees to user groups?", helpText: "Should the user be allowed to add users to user groups?" },
        'can_delete_users_from_user_group': { title: "Can delete employees from user groups?", helpText: "Should the user be allowed remove user groups from the employee?" }
    },
    userManagment: {
        title: "User Management",
        password: "Password",
        login: "Login",
        logout: "Logout",
        mail: "E-Mail",
        register: "Register",
        createInstance: "Register and create instance",
        registerBtnTooltip: "Register and create instance",
        registerLink: "**No GibProject account yet?**\n\nCreate your free demo instance now – just click 'Register'!",
        registerTextHeadline: "**Ready to go?**",
        registerDemoMarketingTextHeadline: "**Discover GibProject – Risk-Free!**",
        registerText: "Simply fill out the form, and your GibProject instance will be **created automatically**. This usually takes just a **few minutes**. Once it’s ready, you can log in and get started right away.\n",
        registerDemoMarketingText: "Try GibProject for **free** today and create your own instance in just a few steps. Enjoy **24 hours of full demo access** and see for yourself what it can do.\n\n Want more time to explore or a personal, no-obligation demo? We’re happy to help—just reach out!\n\n *Start now and experience how GibProject can advance your projects.*\n",
        registerSend: "Thank you for registering. Your instance is currently being created—this process usually takes **up to five minutes**.\n\nOnce completed, you can log in to your personal area using your login credentials and get started right away.",
        registerSendHeadline: "**Welcome to GibProject!**"
    },
    employees: {
        employeeHoursReport: "Employee hours report",
        title: "Employees",
        rowFirstName: "First name",
        rowLastName: "Last name",
        rowMail: "E-mail",
        rowShorthandName: "Shorthand",
        rowBirthday: "Birthday",
        password: "Password",
        repeatPassword: "Repeat password",
        setNewPassword: "Set a new password",
        addEmployeeButton: {
            tooltipText: 'Add an employee',
            buttonText: 'Add employee'
        },
    },
    employeeDetailView: {
        title: "Employee",
        tabContractInfo: "Contract",
        tabHours: "Workhours account",
        contractData: "Contract data",
        contactInfo: "Contact information",
        personalInformation: "Personal information",
        qualification: "Employee qualification",
        qualificationPlural: "Employee qualifications",
    },
    employeeContract: {
        contractualHoursOfOvertime: "Contractual satisfied hours of overtime ( per Week )",
        internalCostsPerHour: "Internal costs per hour",
        employmentStatus: {
            employmentRelationship: "Employment relationship",
            PERMANENT: "Permanent employee",
            APPRENTICE: "Apprentice",
            FREELANCER: "Freelancer",
            SHORT_TERM: "Non-permanent employment",
            TRAINEE: "Trainee",
            MINOR_EMPLOYMENT: "Minor employment"
        },
        contractEnd: "Contract end date",
        contractStart: "Contract start date",
        workdayFullTimeSelection: "Full-time week",
        workdayPartTimeSelection: "Part-time week"

    },
    calendar: {
        title: "Calendar",
        calendar: "Calendar",
        workBreak: "Break",
        startDateAt: "Start at",
        finishDateAt: "Finish at",
        hoursOfWork: "Hours of work",
        workingHours: "Working hours",
        workingHoursPlural: "Working hours",
        overtime: "Overtime",
        daysOfVacation: "Leave days",
        vacation: "Leave",
        sickness: "Sickness",
        sicknessOfChild: "Sickness of child",
        periodOfTime: "Period of time",
        day: "Day",
        hour: "Hour",
        hourPlural: "hours",
        minute: "Minute",
        minutePlural: 'minutes',
        time: "Time",
        week: "week",
        month: "month",
        year: "year",
        today: "today",
        nextMonth: "Next month",
        prevMonth: "Previous month",
        nextWeek: "Next week",
        prevWeek: "Previous week",
        nextDay: "Next day",
        prevDay: "Previous day",
        months: {
            january: "January",
            february: "February",
            march: "March",
            april: "April",
            may: "May",
            june: "June",
            july: "July",
            august: "August",
            september: "September",
            october: "October",
            november: "November",
            december: "December"
        },
        weekdays: {
            sunday: "Sunday",
            monday: "Monday",
            tuesday: "Tuesday",
            wednesday: "Wednesday",
            thursday: "Thursday",
            friday: "Friday",
            saturday: "Saturday"
        },
    },
    communication: {
        coms: {
            name: 'Name',
            method: 'Method',
            number: 'Number / address',
            isPersonal: 'Is personal?',
            addContactOption: 'Add contact method'
        },
        methods: {
            TELEPHONE: 'Phone',
            MOBILE: 'Mobile',
            MAIL: 'E-Mail',
            FAX: 'Fax',
        }
    },
    qualifications: {
        refreshRate: "Refresh rate ( in days )",
        lastRefresh: "Last refresh",
        nextRefresh: "Next refresh",
        title: "Qualification name",
        viewTitle: "Qualification",
        viewTitlePlural: "Qualifications"
    },
    employers: {
        office: "Office",
        title: "Employer"
    },
    timesheet_tasks: {
        title: 'Tasks',
        flagLabel: 'Flags',
        predefDescription: 'Textblocks',
        flags: {
            SICKNESS: "Sickness",
            HOLIDAY: "Holiday",
            DESCRIPTION_MANDATORY: "Description mandatory",
            ABSENCE: "Absent",
            INTERNAL: "Intern",
            SICKNESS_CHILD: 'Sickness child',
            HOLIDAY_UNPAID: 'Holiday unpaid',
            MATERNITY_LEAVE: 'Maternity leave'
        }
    },
    projectLog: {
        title: 'Projectlog',
        answer: {
            buttonText: 'Answer',
            tooltipText: 'Create an answer to this entry.'
        },
        mention: {
            buttonText: 'Mention',
            tooltipText: 'Mention other employees to raise attention to this entry.'
        },
        headline: {
            buttonText: 'Headline',
            tooltipText: 'Short and concise text about the content of the message'
        },
        message: {
            buttonText: 'Message',
            tooltipText: 'The message text of the entry'
        },
        category: {
            buttonText: 'Category',
            tooltipText: 'Categorize the entry with other similar entries'
        }
    },
    customers: {
        title: 'Client',
        legacyCustomerNumber: {
            title: 'Legacy customer number',
            helpText: 'Customer number before the system was introduced.'
        },
        customerNumber: {
            title: 'Customer number',
            helpText: 'Customer number, set by the system.'
        }
    },
    contractors: {
        title: 'Contractor'
    },
    externalWork: {
        title: "Fee schedule",
        hasPhases: {
            buttonText: 'Has project phases',
            tooltipText: 'Billed by project phases'
        }
    },
    externalWorkGroup: {
        title: "Fee schedule groups",
        numberOfPhases: "Number of phases",
        hasPhasesWithSameName: "Has phases with the same name as the group ( Example: LPH 1 Umweltveträglichkeitsstudie )",
        hasSpecializedPhaseNames: "Has phases with specialised name. ( Example: LPH 1 Elektro Grundleistungen )"
    },
    projectCommissionState: {
        title: 'Order status',
        includeInBilling: 'Invoice item'
    },
    projectSegmentFilter: {
        forProjects: 'For projects',
        forProjectStage: 'For stages',
        forProjectStagePhase: 'For phases',
        forContractors: 'For contractors',
        forProjectTasks: 'For assignments'
    },
    projectRoles: {
        title: "Project-roles",
        titleSingular: "Project-role",
        defaultPricePerHour: {
            title: "Default retail price / hour",
            helpText: "The default value for retail price per hour."
        },
        priceRange: {
            title: "Price-range",
            helpText: "The retail price per hour may be adjusted inside this range"
        },
        priceRangeMax: "Max price per hour",
        priceRangeMin: "Min price per hour",
    },
    accounting: {
        baseAmount: "Base amount",
        singleItemPriceInclSurcharge: "Single item price (incl. surcharge/discount)",
        addDiscountSurcharge: "Add discount/surcharge",
        discount: "Discount",
        surcharge: "Surcharge",
        discountPlural: "Discounts",
        surchargePlural: "Surcharges",
        itemCount: "Item count",
        units: {
            unitPrice: "Price of single unit",
            title:"Unit",
            types: {
                piece: "Piece",
                hours: "Hours",
                days: "Days",
                percent: "Percent",
                flatrate: "Flatrate",
                numberofitems: "Number of items"
            }
        },
        invoiceMethod: {
            title: 'Invoice method',
            simpleInvoice: {
                title: "Simple invoice",
                shorthand: "Simple invoice",
                helpText: "In a simple invoice, you enter all invoice items manually. Please note that accurate project monitoring is only possible with project invoices."
            },
            projectInvoice: {
                title: "Project invoice",
                shorthand: "Project invoice",
                helpText: "A project invoice fills its invoice items directly from the chosen projects service item."
            }
        },
        serialNumberOverride: {
            title: "Override serial number",
            helpText: "If enabled, the serial number of the invoice can be manually overridden.",
            shorthand: "Override serial number"
        },
        incomingInvoiceBookTitle: "Incoming invoice book",
        paymentConditions: "Payment conditions",
        paidByDate: "Payment target",
        paidByDateInDays: "Days until payment should have been received",
        bankAccountInfo: {
            bankAccountLabel: "Bank account information",
            accountHolder: {
                title: "Account holder",
                helpText: "Name of the account holder"
            },
            bankName: {
                title: "Bank",
                helpText: "Name of the bank."
            },
            iban: {
                title: "IBAN",
                helpText: "International Bank Account Number"
            },
            bic: {
                title: "BIC",
                helpText: "Business Identifier Code ( previously Bank Identifier Code )"
            }
        },
        customer: {
            projectName: {
                title: "Project name from customer",
                shorthand: "Project name customer",
                helpText: "Name of the project from customer, will be displayed in the invoice and e-invoice. If filled in, the project number must be specified."
            },
            supplierNumber: {
                title: "Supplier number from customer",
                shorthand: "Supplier number",
                helpText: "Supplier number from customer"
            },
            orderNumber: {
                title: "Order number from customer",
                shorthand: "Order number",
                helpText: "Order number from customer"
            },
            contractNumber: {
                title: "Contract number from customer",
                shorthand: "Contract number",
                helpText: "Contract number from customer"
            },
            projectNumber: {
                title: "Project number from customer",
                shorthand: "Project number",
                helpText: "Project number from customer.  If filled in, the project name must be specified."
            },
            procurementReference: {
                title: "Procurement reference",
                shorthand: "Procurement reference",
                helpText: "Procurement reference from customer"
            },
            objectReference: {
                title: "Object reference",
                shorthand: "Object reference",
                helpText: "Object reference from customer. Examples: Phonenumber, license plate, insured person"
            }

        },
        vatId: "VAT-ID",
        title: "Outgoing invoice book",
        lastBilledPerformance: "Performance last invoice",
        billedAmount: "Amount billed",
        billedPerformance: "Billed performance (%)",
        leitwegId: {
            title: "Leitweg-ID",
            shorthand: "LW-ID",
            helpText: "Leitweg-ID is a german identification number, which is mostly used by public clients."
        },
        taxId: "Tax-ID",
        netOfTax: {
            title: "Net of tax",
            shorthand: "Net",
            helpText: ""
        },
        gross: {
            title: "Gross",
            shorthand: "Gross",
            helpText: ""
        },
        salesTax: {
            title: "Sales tax",
            shorthand: "Sales tax",
            helpText: ""
        },
        prePayment: "Prepayment",
        modeTitle: "State",
        mode: {
            canceled: "Canceled",
            done: "Final",
            inProcess: "In process"
        },
        serialNumberProvisional: "provisional",
        invoiceItems: "Invoice items",
        typeTitle: "Invoice type",
        invoiceNumber: "Rechnungsnummer",
        serialNumber: {
            title: "Serial number",
            shorthand: "SN",
            helpText: "Serial number is only given temporary, it may change, when invoice is finalized"
        },
        serialNumberReserved: {
            title: "Serial number reservation",
            shorthand: "SN reservation",
            helpText: "Serial number does not changes again."
        },
        invoiceDate: "Invoice date",
        payedBillAmount: {
            title: "Payed amount",
            shorthand: 'Payed amount',
            helpText: "Payed amount of one or more bills by contractors."
        },
        openBillAmount: {
            title: "Open amount",
            shorthand: 'Open amount',
            helpText: "Difference between payed and stipulated bill amount."
        },
        uncheckedBillAmount: {
            title: "Stipulated amount",
            shorthand: 'Stip. amount',
            helpText: "Stipulated amount of one or more bills by contractors."
        },
        type: {
            partialInvoice: {
                title: "Partial invoice",
                shorthand: "PI",
                helpText: ""
            },
            finalInvoice: {
                title: "Final invoice",
                shorthand: "FI",
                helpText: ""
            },
            singleInvoice:{
                title: "Single invoice",
                shorthand: "SI",
                helpText: ""
            }
        },
        incomingInvoice: {
            title: "Incoming invoice"
        },
        approvedAmountOwed: "Approved amount",
        contractorAmountBilled: "Contractor invoice amount",
        approvedPerformance: "Approved performance",
        payments: "Payments",
        payment: "Payment",
        finalInvoiceAmount: "Invoice amount",
        uploadInvoice: "Upload invoice",
        generateInvoice: "Generate invoice",
        chooseTemplate: "Choose invoice template",
        invoiceFinalError: "The chosen project already has a final invoice. You can only add more single invoices. If the old final invoice was erroneous, cancel the old final invoice.",
        cancel: "Cancel",
        reminderToUseBookKeeping: "Please remember to add the invoice to your book keeping",
        finalize: "Finalize",
        finalizeConfirmText: "Do you really want to finalize the invoice? This step cannot be taken back!",
        cancelConfirmText: "Do you really want to cancel the invoice? This step cannot be taken back!",
        invoiceForCanceled: "Invoice for canceled",
        contractorBilledPerformance: "Contractor performance"

    },
    externalWorkArea: {
        title: "Specialised Area"
    },
    usercp: {
        title:"User control panel",
        settings: "Settings"
    },
    mainMenu: {
        outgoing_invoice: {title: "Outgoing invoices"},
        incoming_invoice: {title: "Incoming invoices"},
        solvency_projection: {title: "Project liquidity projection"},
        project_report: {title: "Project report"},
        project_roles: {title: "Project roles"},
        commission_state: {title: "Order state"},
        reporting_employees_hours: {title: "Employee hours report"},
        external_work_groups: {title: "Fee schedule groups"},
        external_works: {title: "Fee schedule"}
    },
    team: {
        title: "Team",
        newButton: {
            tooltipText: "Create new team",
            buttonText: "New team"
        },
        deleteButton: {
            tooltipText: "Delete team",
            buttonText: "Delete"
        },
        editButton: {
            tooltipText: "Edit team",
            buttonText: "Edit"
        }
    },
    api_keys: {
        title: "API Keys",
        validUntil: "Valid until",
        keyInfoMsg: "The API key is required to use the API. Keep the key safe. The user interface will never display the key. If it is lost, delete the old key and generate a new one."
    }



};
